<template>
    <div class="v-input">
        <label v-if="label" :for="id">{{ label }}</label>
        <input :id="id" :type="type" :placeholder="placeholder" :value="modelValue" @input="handleInput"
            :class="{ 'v-input--error': error }" :disabled="disabled" :maxlength="maxlength" />
        <span v-if="error" class="v-input__error-text">{{ error }}</span>
    </div>
</template>

<script>
export default {
    name: 'VInput',
    props: {
        modelValue: {
            type: [String, Number],
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'text'
        },
        id: {
            type: String,
            default: () => Math.random().toString(36).substr(2, 9)
        },
        error: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        // Enable phone masking
        isPhone: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        maxlength() {
            if (this.isPhone) return 18;
            return null;
        }
    },
    methods: {
        handleInput(event) {
            let value = event.target.value;

            if (this.isPhone) {
                value = this.formatPhone(value);
            }

            this.$emit('update:modelValue', value);
        },
        formatPhone(value) {
            let input = value.replace(/\D/g, '');
            let formatted = '';

            if (!input) {
                return '';
            }

            if (['7', '8', '9'].indexOf(input[0]) > -1) {
                if (input[0] === '9') input = '7' + input;
                let firstSymbols = (input[0] === '8') ? '8' : '+7';
                formatted = firstSymbols + ' ';
                if (input.length > 1) {
                    formatted += '(' + input.substring(1, 4);
                }
                if (input.length >= 5) {
                    formatted += ') ' + input.substring(4, 7);
                }
                if (input.length >= 8) {
                    formatted += ' ' + input.substring(7, 9);
                }
                if (input.length >= 10) {
                    formatted += '-' + input.substring(9, 11);
                }
            } else {
                formatted = '+' + input.substring(0, 16);
            }

            return formatted;
        }
    }
}
</script>

<style lang="scss">
.v-input {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;

    input {

        &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }
    }

    &--error {
        border-color: var(--color-input-error) !important;
    }

    &__error-text {
        color: var(--color-input-error);
        font-size: 0.8rem;
    }
}
</style>
